import API from "@/api/lib/api";

export const getAllMixAndMatches = async (restaurant_id) => {
  try {
    const response = await API.get(`restaurant/${restaurant_id}/mix-and-matches`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getSingleMixAndMatch = async (id) => {
  try {
    const response = await API.get(`restaurant/mix-and-matches/${id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const createMixAndMatch = async (data) => {
  try {
    const response = await API.post(`restaurant/mix-and-matches`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const updateMixAndMatch = async (id, data) => {
  try {
    const response = await API.put(`restaurant/mix-and-matches/${id}`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const toggleMixAndMatchStatus = async (id) => {
  try {
    const response = await API.put(`restaurant/mix-and-matches/${id}/toggle-status`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const deleteMixAndMatch = async (id) => {
  try {
    const response = await API.delete(`restaurant/mix-and-matches/${id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};
